
import useCadmObject from '../../../hooks/useCadmObject'

import TextArea from './TextArea'

const CustomFields = (props) => {
    const customFields = props.customFields
    const setCustomFields = props.setCustomFields
    const cadmObjectType = props.cadmObjectType
    const disabled = props.disabled

    const onChange = (event) => {
        event.preventDefault()
        
        const fieldID = event.target.name
        const value = event.target.value
        
        let fields = customFields.filter(function (field) {
            if(field.cadm_object_custom_field_id == fieldID) {
                field.text_value = value
            }
            return true
        });
        setCustomFields(fields)
    }
    
    let render = []

    customFields.map(function(field) {
        if( field.type == "TEXT" ) {
            render.push(
                <div className="form-group" key={field.cadm_object_custom_field_id}>
                    <label className="col-sm-2 control-label">{field.name}</label>
                    <div className="col-sm-8">
                        <input className="form-control"
                               type="text"
                               name={field.cadm_object_custom_field_id}
                               value={field.text_value}
                               onChange={onChange}
                               disabled={disabled}
                        />
                    </div>
                </div>
            )
        }
        if( field.type == "LARGE_TEXT" ) {
            render.push(
                <div className="form-group" key={field.cadm_object_custom_field_id}>
                    <label className="col-sm-2 control-label">{field.name}</label>
                    <div className="col-sm-8">
                        <TextArea className="form-control"
                                  name={field.cadm_object_custom_field_id}
                                  value={field.text_value}
                                  onChange={onChange}
                                  disabled={disabled} />
                    </div>
                </div>
            )
        }
    })
    return render

}
export default CustomFields
